import { useEffect, useRef, useState } from "react";
import "./copy-toast.scss";

const EXIT_DURATION_MS = 300;

interface CopyToastProps {
	visible: boolean;
	text: string;
}

export const CopyToast = ({ visible, text }: CopyToastProps) => {
	const [rendered, setRendered] = useState(false);
	const [exiting, setExiting] = useState(false);
	// Держим последний текст, чтобы он не пропал во время fade-out
	const lastTextRef = useRef(text);
	if (text) lastTextRef.current = text;

	useEffect(() => {
		if (visible) {
			setExiting(false);
			setRendered(true);
		} else if (rendered) {
			setExiting(true);
			const id = window.setTimeout(() => setRendered(false), EXIT_DURATION_MS);
			return () => window.clearTimeout(id);
		}
	}, [visible]);

	if (!rendered) return null;

	return (
		<div className={`copy-toast${exiting ? " copy-toast--exiting" : ""}`}>
			<span className='copy-toast__label'>Скопійовано:</span>
			<span className='copy-toast__text'>{lastTextRef.current}</span>
		</div>
	);
};
